<template>
  <div :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='24'>
          <a-col :span='10'>
            <a-form-item :label="'日期'" :labelCol='{span: 6}' :wrapperCol='{span: 14, offset: 1}'>
              <a-range-picker
                v-model='queryParam.dataDt'
                format='YYYY-MM-DD' />
            </a-form-item>
          </a-col>
          <a-col :md='4' :sm='6'>
            <a-form-item :label="'批次号'">
              <a-input v-model='queryParam.batchSerial'></a-input>
            </a-form-item>
          </a-col>
          <a-col :md='4' :sm='6'>
            <a-form-item :label="'状态'">
              <a-select default-value='' style='width: 120px' v-model='queryParam.status'>
                <a-select-option value=''>
                  全部
                </a-select-option>
                <a-select-option value='0'>
                  待放款
                </a-select-option>
                <a-select-option value='1'>
                  已放款
                </a-select-option>
                <a-select-option value='2'>
                  已回执
                </a-select-option>
                <a-select-option value='3'>
                  已完成
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
              <a-button type='primary' @click='searchReset' icon='reload'
                        style='margin-left: 8px'>{{ $t('reset') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='ipagination'
        :loading='loading'
        bordered
        @change='handleTableChange'>
         <span slot='action' slot-scope='text, record'>
           <a @click='viewPlans(record.batchSerial,record.batchDate)' :disabled="!downloadAble">查看</a>

           &nbsp;&nbsp;

           <a-popconfirm title='确定已操作放款吗?' @confirm='() =>updateStatus(record.id)' v-show='record.batchStatus == 0'>
            <a>已放款</a>
          </a-popconfirm>

            &nbsp;&nbsp;
           <a @click='exportBatch(record.batchSerial)' :disabled="!downloadAble" v-show='record.batchStatus == 1|| record.batchStatus == 2'>下载</a>
           &nbsp;&nbsp;
           <a-upload
             name='file'
             :multiple='true'
             :action="'/api/web/webpublic/payoutBat/importBatchResult/' + record.batchSerial"
             :headers='getHeaders()'
             :data='{}'
             @change = "uploadResult"
             v-show='record.batchStatus == 1 || record.batchStatus == 2'
           >
              <a-button @click='clickUploadFile' style='margin-left: 6px'>
                <a-icon type='upload' />
                导入结果
              </a-button>
            </a-upload>

           <a @click="confirmPayoutResult(record.id)" v-show='record.batchStatus == 2'>{{ '已完成' }}</a>
        </span>
      </a-table>

    </div>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import {
  listBatch,
  updateBatchStatus,
  exportBatchOrders,
  countBatchStatus,
  updatePendingOrders
} from '@/webpublicapi/payoutBank'

import moment from 'moment/moment'
import { getHeaders } from '@/utils/request'

const I18N_KEY = 'order.'
export default {
  name: 'listBankBat',
  data() {
    return {
      I18N_KEY,
      toggleSearchStatus: false,
      visible: false,
      downloadAble: true,
      // 分页参数
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      total: 0,
      dataSource: [],
      appList: [],
      // 查询条件
      queryParam: {
        dataDt: [moment(),moment()],
        batchSerial: '',
        status: ''
      },

      loading: false,
      // 表头
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '批次号',
          align: 'left',
          dataIndex: 'batchSerial'
        },
        {
          title: '日期',
          align: 'left',
          dataIndex: 'batchDate'
        },
        {
          title: '订单数',
          align: 'left',
          dataIndex: 'batchNumber'
        },
        {
          title: '总金额',
          align: 'left',
          dataIndex: 'batchAmount'
        },
        {
          title: '状态',
          align: 'left',
          dataIndex: 'batchStatus',
          customRender: (text) => {
            console.log(text)
            if (text == '0')
              return '待放款' // 转换状态码
            else if (text == '1')
              return '已放款'
            else if (text == '2')
              return '已回执'
            else if (text == '3')
              return '已完成'
            return ''
          }
        },
        {
          title: '更新时间',
          align: 'left',
          dataIndex: 'updateTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: '300px',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created() {
    this.loadData(1)
  },
  methods: {
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    searchQuery() {
      this.loadData(1)
    },
    getHeaders() {
      return getHeaders()
    },
    clickUploadFile() {
    },
    loadData(arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      const params = this.getQueryParams()// 查询条件
      listBatch(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.ipagination.total = res.data.total
          this.dataSource = res.data.rows
        } else {
          this.ipagination.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    getQueryParams() {
      const { dataDt } = this.queryParam

      const data = {
        ...this.queryParam,
        dateStart: (dataDt && dataDt.length) ? this.transformTime(dataDt[0]) : undefined,
        dateEnd: (dataDt && dataDt.length) ? this.transformTime(dataDt[1]) : undefined
      }
      delete data.dataDt

      data.pageNum = this.ipagination.current
      data.pageSize = this.ipagination.pageSize
      return filterObj(data)
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    updateStatus(id) {
      updateBatchStatus({ batchId: id}).then((res) => {
        if (res.code === 1000) {
          this.$message.success(res.msg)
          this.loadData()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    confirmPayoutResult (batchId) {
      // 加载数据 若传入参数1则加载第一页的内容
      this.loading = true

      countBatchStatus({ batchId: batchId}).then((res)=>{
        if(res.code===1000){
          this.$confirm({
            title: '确认回执完成',
            content: "本批次放款成功/失败/未处理数量为：" + res.data.successCount + "/" + res.data.failedCount + "/" + res.data.pendingCount + ", 是否确认放款完成，未处理将会标记为放款失败？",
            onOk: () => {
              updatePendingOrders({ batchId: batchId}).then((res)=>{
                if(res.code===1000){
                  this.$message.info("处理成功，" + res.data.successCount + "条未处理订单，已置为放款失败")
                }else{
                  this.$message.error(res.msg)
                }
              }).catch(e => {
                this.$message.error(e.message);
              })

              this.loadData(1)
            },
            onCancel: () => {
              this.loading = false
            }
          })
        }else{
          this.$message.error(res.msg)
          this.loading = false
        }
      }).catch(e => {
        this.$message.error(e.message);
        this.loading = false
      })

    },
    exportBatch(batchSerial) {
      this.downloadAble = false;
      exportBatchOrders({ batchSerial: batchSerial }).then((res) => {

        try {

          // 创建 Blob 对象并生成下载链接
          const blob = new Blob([res], {
            type: 'application/vnd.ms-excel;charset=utf-8'
          })

          const downloadUrl = URL.createObjectURL(blob)

          // 动态创建 a 标签触发下载
          const link = document.createElement('a')
          link.href = downloadUrl
          link.download = batchSerial + '_' + new Date() + '.xlsx'  // 自定义文件名获取逻辑:ml-citation{ref="8" data="citationList"}
          document.body.appendChild(link)
          link.click()

          // 清理临时对象
          URL.revokeObjectURL(downloadUrl)
          document.body.removeChild(link)
        } catch (error) {
          console.error('下载失败:', error)
          this.$message.error('文件下载失败，请重试')

        }
        this.downloadAble = true;
      })
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      const that = this

      that.queryParam.dataDt = [moment(),moment()]
      that.queryParam.batchSerial = ''
      that.queryParam.status = ''

    },
    changeModal(visible) {
      this.visible = visible
    },
    uploadResult(info)
    {
      if(info.file && info.file.status && info.file.status === 'done')
        this.loadData(1)
    },
    viewPlans(batchSerial,date)
    {
      if(sessionStorage.getItem('listBankPlanParam'))
          sessionStorage.setItem('listBankPlanParamOld', sessionStorage.getItem('listBankPlanParam'));

      sessionStorage.setItem('listBankPlanParam', JSON.stringify({ batchSerial: batchSerial, date: date }));

      this.$router.push('/webpublic/payoutBank/ListBankPlan')
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
